import { makeObservable, observable, runInAction} from "mobx";
import { IJackpotHandler } from "../jackpots/jackpot-handler/jackpot-handler.interface";
import { IJackpotData } from "../jackpots/jackpots.service.interface";
import { IServiceFactoryExtended } from "../service-factory-extended.interface";
import { ServiceBase } from "../ServiceBase";
import { ITitanJackpotService } from "./titan-jackpot.service.interface";

export class TitanJackpotService extends ServiceBase implements ITitanJackpotService {
    constructor(serviceFactory: IServiceFactoryExtended) {
        super(serviceFactory);
    
        makeObservable(this);
      }

    @observable.ref
    jackpotHandler: IJackpotHandler;


    public updateJackpotHandler(jackpotId: string): void {
        this.services.jackpots.then(jackpots => {
            runInAction(() => {
                this.jackpotHandler = jackpots.currentJackpotsById[jackpotId];

                const jackpotData = (this.jackpotHandler?.jackpotData || {}) as IJackpotData;

                this.jackpotHandler.forceGradual(jackpotData);
            })
        })

    }    
}